import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const OpenedEyeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  // parse width and height from props as number
  let width = props.width ?? props.size ?? 24;
  if (typeof width === "string") {
    width = parseInt(width);
  }
  let height = props.height ?? props.size ?? width / (24 / 16);
  if (typeof height === "string") {
    height = parseInt(height);
  }

  return (
    <IconBase
      width={width}
      height={height}
      viewBox="0 0 24 16"
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path
              d="M11.8889 1C4.11111 1 1 8 1 8C1 8 4.11111 15 11.8889 15C19.6667 15 22.7778 8 22.7778 8C22.7778 8 19.6667 1 11.8889 1Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              fill="transparent"
            />
            <path
              d="M11.8889 11.889C14.0367 11.889 15.7778 10.1479 15.7778 8.0001C15.7778 5.85232 14.0367 4.11121 11.8889 4.11121C9.74111 4.11121 8 5.85232 8 8.0001C8 10.1479 9.74111 11.889 11.8889 11.889Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              fill="transparent"
            />
          </>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

OpenedEyeIcon.displayName = "OpenedEyeIcon";

export { OpenedEyeIcon };
